<template>
  <div class="dialog-wrap">
    <el-dialog title="学长审核"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               top="10px"
               @close="close()"
               @opened="open()"
               width="1400px">

      <div class="senioBox">
        <div class="seniorItem">
          <div class="invite"
               style="marginTop:0px">
            <span class="blue"></span>
            <p>邀请信息</p>
          </div>
          <el-form ref="userForm"
                   label-width="55px"
                   class="userForm">
            <el-form-item label="邀请人">
              <el-input v-model="senior.nickname"
                        disabled
                        style="width:270px"
                        placeholder="是邀请人名称"
                        clearable></el-input>
            </el-form-item>
          </el-form>
          <div class="invite">
            <span class="blue"></span>
            <p>基础信息</p>
          </div>
          <el-form ref="userForm"
                   size="mini"
                   label-width="80px"
                   class="userForm"
                   style="marginLeft:-30px;">
            <!-- <el-form-item label="头像">
              {{senior.avatar}}
              <el-avatar :src="senior.avatar"></el-avatar>
            </el-form-item> -->
            <el-form-item label="姓名">
              <el-input v-model="senior.realname"
                        clearable></el-input>
              <p class="warning"
                 v-if="olderSenior && olderSenior.realname && senior.realname != olderSenior.realname">姓名：{{olderSenior.realname}}</p>
            </el-form-item>
            <el-form-item label="昵称">
              <el-input v-model="senior.nickname"
                        clearable></el-input>
              <p class="warning"
                 v-if="olderSenior && olderSenior.nickname && senior.nickname != olderSenior.nickname">昵称：{{olderSenior.nickname}}</p>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="senior.gender">
                <el-radio :label="1">学长</el-radio>
                <el-radio :label="2">学姐</el-radio>
                <el-radio :label="0">未知</el-radio>
              </el-radio-group>
              <p class="warning"
                 v-if="olderSenior && olderSenior.gender && senior.gender != olderSenior.gender">性别：{{olderSenior.gender==1 ?'学长':'学姐'}}</p>
            </el-form-item>
            <el-form-item label="个人简介">
              <el-input v-model="senior.additional"
                        type="textarea"
                        clearable></el-input>
              <p class="warning"
                 v-if="olderSenior && olderSenior.additional && senior.additional != olderSenior.additional">个人简介：{{olderSenior.additional}}</p>

            </el-form-item>
          </el-form>

          <div class="invite">
            <span class="blue"></span>
            <p>录取信息</p>
          </div>
          <el-form ref="userForm"
                   label-width="100px"
                   class="userForm"
                   style="width:300px;marginLeft:-50px;">
            <el-form-item label="考研年份">
              <el-input v-model="senior.recruit_year"
                        clearable
                        maxlength="4"
                        style="width: 270px"></el-input>
              <p class="warning"
                 v-if="olderSenior && olderSenior.recruit_year && senior.recruit_year != olderSenior.recruit_year">考研年份：{{olderSenior.recruit_year}}</p>
            </el-form-item>
            <el-form-item label="录取院校">
              <el-select v-model="senior.recruit_college_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 270px"
                         @change="collegeChange">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
              <p class="warning"
                 v-if="olderSenior && olderSenior.recruit_college_code && senior.recruit_college_code != olderSenior.recruit_college_code">录取院校：{{olderSenior.recruit_college_name}}</p>
            </el-form-item>
            <el-form-item label="录取学院">
              <el-select v-model="senior.recruit_academy_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 270px"
                         @change="academyChange">
                <el-option v-for="(item, index) in academyList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `${item.name}` }}</span>
                </el-option>

              </el-select>
              <p class="warning"
                 v-if="olderSenior && olderSenior.recruit_academy_code && senior.recruit_academy_code != olderSenior.recruit_academy_code">录取学院：{{olderSenior.recruit_academy_name}}</p>
            </el-form-item>
            <el-form-item label="录取专业">
              <el-select v-model="senior.recruit_major_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 270px"
                         @change="majorChange">
                <el-option v-for="(item, index) in majorList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>

              </el-select>
              <p class="warning"
                 v-if="olderSenior && olderSenior.recruit_major_code && senior.recruit_major_code != olderSenior.recruit_major_code">录取专业：{{olderSenior.recruit_major_name}}</p>
            </el-form-item>
            <el-form-item label="研究方向">
              <el-select v-model="senior.recruit_direction_code"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         style="width: 270px"
                         @change="directionChange">
                <el-option v-for="(item, index) in directionList"
                           :key="index"
                           :label="item.direction"
                           :value="item.direction_code">
                  <span>{{ `${item.direction}` }}</span>
                </el-option>

              </el-select>
              <p class="warning"
                 v-if="olderSenior && olderSenior.recruit_direction_name && senior.recruit_direction_name != olderSenior.recruit_direction_name">研究方向：{{olderSenior.recruit_direction_name}}</p>
            </el-form-item>
            <el-form-item label="初试总分">
              <el-input v-model="senior.initial_test_score"
                        clearable
                        maxlength="4"
                        style="width: 270px"><template slot="append">分</template></el-input>

              <p class="warning"
                 v-if="olderSenior && olderSenior.initial_test_score && senior.initial_test_score != olderSenior.initial_test_score">初试总分：{{olderSenior.initial_test_score}}</p>
            </el-form-item>
          </el-form>
        </div>

        <div class="seniorItem">
          <el-form ref="userForm"
                   label-width="100px"
                   class="userForm">
            <el-form-item label="初试科目">
              <el-select v-model="senior.test_subject_codes"
                         multiple
                         clearable
                         placeholder="请选择"
                         style="width: 200px"
                         @change="handleSubject">
                <el-option v-for="(item, index) in subjectsList"
                           :key="index"
                           :label="item.subject_name"
                           :value="item.subject_code">
                  <span>{{
                    `（${item.subject_code}）${item.subject_name}`
                  }}</span>
                </el-option>
              </el-select>
              <p class="warning"
                 v-if="olderSenior && olderSenior.test_subject_codes && senior.test_subject_codes != olderSenior.test_subject_codes">初试科目：{{olderSenior.test_subject_names}}</p>
            </el-form-item>
            <el-form-item label="科目分数">
              <div v-for="(item,index) in scoreList"
                   :key="index"
                   :label="item.subjectName+'：'"
                   style="display:flex; align-items:center;">
                <div class="score">
                  <div class="subjectName">{{item.subjectName}}</div>
                  <el-input v-model="item.score"
                            border="none"
                            style="width:90px;height:100%"
                            class="inptScore"></el-input>
                  <span class="preScore">分</span>

                </div>
                <span class="warning"
                      style="marginLeft:10px;marginTop:10px"
                      v-if="olderSenior && olderSenior.test_subject_scores && item.score != olderSenior.test_subject_scores.split(',')[index]">{{olderSenior.test_subject_scores.split(',')[index]}}分</span>
              </div>

            </el-form-item>
            <el-form-item label="录取类型">
              <el-radio-group v-model="senior.recruit_type">
                <el-radio :label="1">一志愿</el-radio>
                <el-radio :label="2">调剂</el-radio>
              </el-radio-group>
              <p class="warning"
                 v-if="olderSenior && olderSenior.recruit_type && senior.recruit_type != olderSenior.recruit_type">初试科目：{{olderSenior.recruit_type==1 ?'一志愿' :'调剂'}}</p>
            </el-form-item>

            <div class="invite"
                 style="marginLeft:20px">
              <span class="blue"></span>
              <p>身份信息</p>
            </div>
            <el-form-item label="荣誉称号："
                          style="marginTop:10px">
              <el-select v-model="honors"
                         multiple
                         style="width: 250px"
                         clearable
                         placeholder="请选择"
                         @change="handleSubject">
                <el-option v-for="(item, index) in honorList"
                           :key="index"
                           :label="item.label"
                           :value="item.id">
                </el-option>
              </el-select>

              <p class="warning"
                 v-if="olderSenior && olderSenior.honor_tags && senior.honor_tags != olderSenior.honor_tags">荣誉称号：{{olderSenior.honor_tags}}</p>
            </el-form-item>
            <el-form-item label="其他荣誉：">
              <el-input v-model="otherHonor"
                        type="textarea"
                        :rows="2"></el-input>

            </el-form-item>
            <el-form-item label="身份证明：">
              <el-upload :action="imgUploadUrl"
                         :headers="uploadHeaders"
                         list-type="picture-card"
                         :on-preview="handlePictureCardPreview"
                         :on-remove="handleRemove"
                         :on-success="handleSuccess"
                         :file-list="fileList">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogImageVisible"
                         :append-to-body="true">
                <img width="100%"
                     :src="dialogImageUrl"
                     alt="">
              </el-dialog>

              <!-- <el-image style="width: 140px; height: 140px"
                        :src="senior.recruit_certify_img"
                        :preview-src-list="[senior.recruit_certify_img]">
              </el-image> -->
            </el-form-item>
            <div v-if="olderSenior && olderSenior.recruit_certify_img && senior.recruit_certify_img  != olderSenior.recruit_certify_img"
                 class="warning certify"> <span>身份证明：</span>
              <el-image :src="olderSenior.recruit_certify_img"
                        style="width:80px;height:80px;marginBottom:10px;border:1px solid #ed7b2f"> </el-image>
            </div>

            <el-form-item label="视频简介：">
              <video width="80px"
                     height="80px"
                     :src="senior.intro_video_url"
                     style="border:1px solid #DCDFE6"></video>

            </el-form-item>
          </el-form>
        </div>

        <div class="seniorItem"
             style="border:none;marginLeft:30px ;width:300px">
          <el-form ref="userForm"
                   :model="userForm"
                   :rules="rules"
                   label-width="80px"
                   class="userForm"
                   style="width:400px">
            <div class="invite">
              <span class="blue"></span>
              <p>其他可辅导大学生考试项</p>
              <p class="addSubject"
                 @click="handleAddSubject()">
                +添加科目
              </p>
            </div>
            <!-- 考试辅导项 -->
            <div class="tutoringBox"
                 v-for="(item,index) in tutorCheckList"
                 :key="index">
              <p class="tutorName">{{item.name}}</p>
              <p class="tutoringDelete"
                 @click="handleDelete(item)">删除</p>
              <el-form-item label="辅导科目："
                            style="marginTop:10px">
                <el-select v-model="item.extra_tutoring_types"
                           clearable
                           placeholder="请选择"
                           style="width: 320px"
                           @change="handleSubject">
                  <el-option v-for="(item, index) in tutorList"
                             :key="index"
                             :label="item.value"
                             :value="item.id">
                    <span>{{
                    item.value
                  }}</span>
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="辅导形式"
                            style="marginTop:10px">
                <el-select v-model="item.extra_service_types"
                           clearable
                           multiple
                           placeholder="请选择"
                           style="width: 320px">
                  <el-option v-for="(item, index) in tutorService"
                             :key="index"
                             :label="item.value"
                             :value="item.id">
                    <span>{{
                    item.value
                  }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="辅导证明："
                            style="marginTop:10px">
                <el-input v-model="item.extra_tutoring_certify_text"
                          type="textarea"
                          style="width: 320px;marginBottom:10px"
                          clearable></el-input>
                <el-upload :action="imgUploadUrl"
                           :headers="uploadHeaders"
                           list-type="picture-card"
                           :on-preview="TutorPictureCardPreview"
                           :on-remove="TutorRemove"
                           :on-success="(res, file, fileList) => TutorleSuccess(res, file, fileList, item)"
                           :file-list="item.tutoring_certify_img">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </div>

            <div class="invite">
              <span class="blue"></span>
              <p>审核</p>
            </div>
            <el-form-item label="审核结果"
                          prop="status"
                          style="marginTop:10px">

              <el-radio-group v-model="userForm.status">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">驳回</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="驳回理由"
                          prop="rejection"
                          v-if="userForm.status==2">
              <el-input type="textarea"
                        maxlength="100"
                        placeholder="请输入内容"
                        v-model="userForm.rejection">
              </el-input>
            </el-form-item>
            <div class="submit">
              <div class="cancle"
                   @click="close()">取消</div>
              <div class="confirm"
                   @click="confirm()">确认</div>
            </div>
          </el-form>
        </div>

      </div>

    </el-dialog>

    <AddSubject :visible="subjectVisible"
                @chooseList="chooseList"
                @close="tutorClose()" />
  </div>
</template>

<script>
import {
  seniorApplyOne,
  editSeniorApply,
  seniorApplyApprove,
  seniorApplyReject,
} from '@/api/senior'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import AddSubject from '@/components/dialog/addSubject/index'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    curentSenior: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: { AddSubject },
  data() {
    return {
      subjectVisible: false,
      dialogVisible: this.visible,
      mylabel: {
        width: '120px',
      },
      tutorService: [
        {
          id: '1',
          value: '1v1辅导（含答疑）',
        },
        {
          id: '2',
          value: '1v1辅导（纯答疑）',
        },
      ],
      olderSenior: { additional: '' },
      senior: {},
      majorList: [],
      subjectsList: [],
      academyList: [],
      directionList: [],
      collegeCode: '',
      majorCode: '',
      scoreList: [],
      honors: [],
      // honor: ['初试第一', '专业课第一', '总分第一'],
      honorList: [
        {
          id: 0,
          label: '初试总分第一',
          ischeck: false,
        },
        {
          id: 1,
          label: '专业综合第一',
          ischeck: false,
        },
        {
          id: 2,
          label: '复试成绩第一',
          ischeck: false,
        },
        {
          id: 3,
          label: '跨考高分上岸',
          ischeck: false,
        },
        {
          id: 4,
          label: '逆袭上岸典范',
          ischeck: false,
        },
        {
          id: 5,
          label: '总分 400+',
          ischeck: false,
        },
        {
          id: 6,
          label: '数学 140+',
          ischeck: false,
        },
        {
          id: 7,
          label: '英语 80+',
          ischeck: false,
        },
        {
          id: 8,
          label: '政治 75+',
          ischeck: false,
        },
        {
          id: 9,
          label: '国家奖学金',
          ischeck: false,
        },
        {
          id: 10,
          label: '校级一等奖学金',
          ischeck: false,
        },
        {
          id: 11,
          label: '校级二等奖学金',
          ischeck: false,
        },
        {
          id: 12,
          label: '专项奖学金获得者',
          ischeck: false,
        },
        {
          id: 13,
          label: '学业优秀奖',
          ischeck: false,
        },
        {
          id: 14,
          label: '科研创新奖学金',
          ischeck: false,
        },

        {
          id: 15,
          label: '四级 600+',
          ischeck: false,
        },
        {
          id: 16,
          label: '六级 550+',
          ischeck: false,
        },
        {
          id: 17,
          label: '六级 600+',
          ischeck: false,
        },
        {
          id: 18,
          label: '雅思 7.0+',
          ischeck: false,
        },
        {
          id: 19,
          label: '托福 100+',
          ischeck: false,
        },
        {
          id: 20,
          label: '专四优秀',
          ischeck: false,
        },
        {
          id: 21,
          label: '专八通过',
          ischeck: false,
        },

        {
          id: 22,
          label: '校级科研项目参与',
          ischeck: false,
        },
        {
          id: 23,
          label: '省级竞赛获奖',
          ischeck: false,
        },
        {
          id: 24,
          label: '发表学术论文',
          ischeck: false,
        },
        {
          id: 25,
          label: '专利持有',
          ischeck: false,
        },
        {
          id: 26,
          label: '计算机二级证书',
          ischeck: false,
        },
        {
          id: 27,
          label: '教师资格证书',
          ischeck: false,
        },
        {
          id: 28,
          label: '实验室助理',
          ischeck: false,
        },

        {
          id: 29,
          label: '往届辅导上岸率 90%+',
          ischeck: false,
        },
        {
          id: 30,
          label: '1v1 辅导超百人次',
          ischeck: false,
        },
        {
          id: 31,
          label: '押中考研真题考点',
          ischeck: false,
        },
        {
          id: 32,
          label: '资料被千人收藏',
          ischeck: false,
        },
        {
          id: 33,
          label: '学员口碑五星好评',
          ischeck: false,
        },
        {
          id: 34,
          label: '高分学员孵化导师',
          ischeck: false,
        },
        {
          id: 35,
          label: '校级优秀毕业生',
          ischeck: false,
        },
        {
          id: 36,
          label: '三好学生标兵',
          ischeck: false,
        },
        {
          id: 37,
          label: '优秀学生干部',
          ischeck: false,
        },
        {
          id: 38,
          label: '社会实践先进个人',
          ischeck: false,
        },
        {
          id: 39,
          label: '志愿服务之星',
          ischeck: false,
        },
        {
          id: 40,
          label: '初试第一',
          ischeck: false,
        },
        {
          id: 41,
          label: '专业课第一',
          ischeck: false,
        },
        {
          id: 42,
          label: '总分第一',
          ischeck: false,
        },
      ],
      otherHonor: '',
      status: '1',
      rejection: '',
      userForm: { status: 1, rejection: '' },
      rules: {
        status: [
          { required: true, message: '请选择审核结果', trigger: 'change' },
        ],
        rejection: [
          { required: true, message: '请输入驳回理由', trigger: 'blur' },
        ],
      },
      fileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      tutorCheckList: [],
      olderCheckList: [],
      olderCerityImg: '',
      tutorList: [
        {
          id: 101,
          value: '政治',
          isFlag: false,
        },
        {
          id: 102,
          value: '英语一',
          isFlag: false,
        },
        {
          id: 103,
          value: '英语二',
          isFlag: false,
        },
        {
          id: 104,
          value: '数学一',
          isFlag: false,
        },
        {
          id: 105,
          value: '数学二',
          isFlag: false,
        },
        {
          id: 106,
          value: '数学三',
          isFlag: false,
        },
        {
          id: 107,
          value: '英语作文批改',
          isFlag: false,
        },
        {
          id: 108,
          value: '199管理类综合',
          isFlag: false,
        },
        {
          id: 109,
          value: '408计算机综合',
          isFlag: false,
        },

        {
          id: 201,
          value: '复试邮件简历',
          isFlag: false,
        },
        {
          id: 202,
          value: '中英文自我介绍',
          isFlag: false,
        },
        {
          id: 203,
          value: '复试口语',
          isFlag: false,
        },
        {
          id: 204,
          value: '综合面试',
          isFlag: false,
        },
        {
          id: 205,
          value: '调剂指导',
          isFlag: false,
        },
        {
          id: 301,
          value: '高等数学',
          isFlag: false,
        },
        {
          id: 302,
          value: '线性代数',
          isFlag: false,
        },
        {
          id: 303,
          value: '概率论与数理统计',
          isFlag: false,
        },
        {
          id: 304,
          value: '大学物理',
          isFlag: false,
        },
        {
          id: 305,
          value: '材料力学',
          isFlag: false,
        },
        {
          id: 306,
          value: '数字电路与模拟电路',
          isFlag: false,
        },
        {
          id: 307,
          value: '理论力学',
          isFlag: false,
        },
        {
          id: 308,
          value: '电工学',
          isFlag: false,
        },
        {
          id: 309,
          value: '运筹学',
          isFlag: false,
        },
        {
          id: 310,
          value: '机械原理',
          isFlag: false,
        },
        {
          id: 311,
          value: '结构力学',
          isFlag: false,
        },
        {
          id: 312,
          value: '自动控制原理',
          isFlag: false,
        },
        {
          id: 313,
          value: '电路',
          isFlag: false,
        },
        {
          id: 401,
          value: '英语四六级',
          isFlag: false,
        },
        {
          id: 402,
          value: '雅思',
          isFlag: false,
        },
        {
          id: 403,
          value: '托福',
          isFlag: false,
        },
        {
          id: 404,
          value: 'GRE',
          isFlag: false,
        },
        {
          id: 405,
          value: '英语专业四级',
          isFlag: false,
        },
        {
          id: 406,
          value: '英语专业八级',
          isFlag: false,
        },
        {
          id: 407,
          value: '计算机二级',
          isFlag: false,
        },
        {
          id: 501,
          value: '教师资格证',
          isFlag: false,
        },
        {
          id: 502,
          value: '法律职业资格（法考）',
          isFlag: false,
        },
        {
          id: 503,
          value: '证券/基金/银行从业资格',
          isFlag: false,
        },
        {
          id: 504,
          value: '初级会计职称',
          isFlag: false,
        },
        {
          id: 505,
          value: '注册会计师（CPA）',
          isFlag: false,
        },
        {
          id: 506,
          value: '导游资格证',
          isFlag: false,
        },
      ],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    curentSenior: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$nextTick(() => {
            setTimeout(() => {
              this.olderSenior = newValue
              this.olderCerityImg = this.olderSenior.recruit_certify_img
            }, 1000)
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleDelete(item) {
      this.tutorCheckList = this.tutorCheckList.filter((v) => {
        return item.name != v.name
      })
    },
    tutorClose() {
      this.subjectVisible = false
    },
    chooseList(val) {
      this.tutorCheckList.push(val)
    },
    handleAddSubject() {
      this.subjectVisible = true
    },
    handleRemove(file, fileList) {},
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url,
      })
    },
    TutorRemove() {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    TutorPictureCardPreview() {},
    TutorleSuccess(response, file, fileList, item) {
      item.tutoring_certify_img.push({
        url: response.data.url,
      })
    },
    submit() {
      this.$emit('close')
    },
    open() {
      this.fetchSeniorInfo()
      this.$store.dispatch('getAllColleges')
    },
    close() {
      // this.dialogVisible = false
      this.olderSenior = {}
      this.$emit('handleClose')
    },
    //回显基本信息
    TutoringRequire() {
      // 关于辅导要求的回显
      this.tutorCheckList = []
      if (this.senior.extra_tutoring_types != '') {
        const length = this.senior.extra_tutoring_types.split(',').length
        for (let i = 0; i < length; i++) {
          this.tutorCheckList.push({
            tutoring_certify_img: [],
            extra_service_types: [],
            extra_tutoring_certify_text: '',
            extra_tutoring_types: null,
            isFlag: true,
            name: '',
          })
        }
      }
      if (this.tutorCheckList.length > 0) {
        // 辅导id
        this.tutorCheckList.map((item, index) => {
          if (this.senior.extra_service_types != '') {
            //辅导服务形式
            this.senior.extra_service_types.split(',').map((items, v) => {
              if (index == v) {
                if (items.includes('-')) {
                  items.split('-').map((imgItem, imgIndex) => {
                    item.extra_service_types.push(imgItem)
                  })
                } else {
                  if (items != '') {
                    item.extra_service_types.push(items)
                  }
                }
              }
            })
          }

          if (this.senior.extra_tutoring_certify_imgs != '') {
            // 辅导证明图片
            this.senior.extra_tutoring_certify_imgs
              .split(',')
              .map((items, v) => {
                if (index == v) {
                  if (items.includes('-')) {
                    items.split('-').map((imgItem, imgIndex) => {
                      item.tutoring_certify_img.push({
                        url: imgItem,
                        status: 'success',
                      })
                    })
                  } else {
                    if (items != '') {
                      item.tutoring_certify_img.push({
                        url: items,
                        status: 'success',
                      })
                    }
                  }
                }
              })
          }
          //辅导证明文字
          this.senior.extra_tutoring_certify_text
            .split(',')
            .map((textItem, s) => {
              if (index == s) {
                item.extra_tutoring_certify_text = textItem
              }
            })
          //辅导科目id
          this.senior.extra_tutoring_types.split(',').map((typesItem, t) => {
            if (index == t) {
              item.extra_tutoring_types = typesItem * 1
            }
          })
          //映射辅导科目名称
          this.tutorList.map((subjectItem, subIdex) => {
            // subjectItem.fisrtTry.map((fItem, fIndex) => {
            this.senior.extra_tutoring_types
              .split(',')
              .map((typeItem, typeIndex) => {
                if (index == typeIndex) {
                  if (typeItem == subjectItem.id) {
                    item.name = subjectItem.value
                  }
                }
              })
            // })
          })
          // 判断辅导类型是新增还是删除
        })
      }
    },
    // 提取#号后面内容的函数
    getContentAfterHash(str) {
      // 找到最后一个#的位置（处理多个#的情况，取最后一个#之后的内容）
      const hashIndex = str.lastIndexOf('#')

      // 如果找到#号，截取#之后的所有字符；没找到则返回空字符串
      if (hashIndex !== -1) {
        return str.slice(hashIndex + 1) // +1 是为了跳过#本身
      }

      return ''
    },
    // 学长基本信息
    fetchSeniorInfo() {
      seniorApplyOne({ id: this.rowDetail.id }).then((res) => {
        if (res) {
          res.status = res.status == 1 ? true : false
          this.senior = res
          this.TutoringRequire()
          if (this.senior.additional == 'undefined') {
            this.senior.additional = ''
          }
          if (this.senior.recruit_certify_img != '') {
            this.fileList = this.senior.recruit_certify_img
              .split(',')
              .map((v) => {
                return {
                  url: v,
                }
              })
          }
          this.senior.test_subject_codes =
            this.senior.test_subject_codes.split(',')
          this.getAcademy(this.senior.recruit_college_code)
          this.getMajor(
            this.senior.recruit_college_code,
            this.senior.recruit_academy_code
          )
          this.getSubjectsByMajorCode(
            this.senior.recruit_college_code,
            this.senior.recruit_major_code
          )
          this.majorDirect(
            this.senior.recruit_college_code,
            this.senior.recruit_major_code
          )
          this.honors = []
          this.otherHonor = []
          if (this.senior.honor_tags_apply != '') {
            this.senior.honor_tags_apply = this.senior.honor_tags_apply.replace(
              /，/g,
              ','
            )

            this.senior.honor_tags_apply.split(',').map((items, index) => {
              this.honorList.map((v, t) => {
                if (v.label == items) {
                  this.honors.push(v.id)
                }
              })
            })

            let str = this.getContentAfterHash(this.senior.honor_tags_apply)
            str.split(',').map((t) => {
              if (t != '') {
                this.otherHonor.push(t)
              }
              this.otherHonor.join(',')
            })
          }

          this.scoreList = []
          this.senior.test_subject_names.split(',').map((item, index) => {
            this.senior.test_subject_scores.split(',').map((v, id) => {
              if (index == id) {
                this.scoreList.push({
                  subjectName: item,
                  score: v,
                })
              }
            })
          })
          this.scoreList.map((items, k) => {
            this.senior.test_subject_codes.map((p, i) => {
              if (k == i) {
                items.code = ''
                items.code = p
              }
            })
          })
        }
      })
    },
    handleSubject(e) {
      let scorep = []
      this.scoreList.map((item) => {
        e.map((v) => {
          if (item.code == v) {
            scorep.push({
              subjectName: item.subjectName,
              score: item.score,
              code: v,
            })
          }
        })
      })
      this.scoreList = scorep
    },
    // 返回
    // handleClose() {
    //   this.close()
    // },
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    renderProvideService(type) {
      /*    const services = {
           1: "资料：专业课资料/复习书记/笔记等",
           2: "解答：专业课复习相关问题",
           3: "录课：专业课知识点梳理及精讲",
           4: "辅导：参与研发专业课辅导教案并授课",
           5: "其他：考研其他资询辅导服务",
         }; */
      const services = {
        1: '资料-整理备考资料',
        2: '经验-分享上岸经验',
        3: '小讲-录制语音课程',
        4: '辅导-辅导1v1学员',
        5: '研讯-汇总专业数据',
      }
      return services[type] || ''
    },
    renderRecruitType(type) {
      const recruitTypes = {
        1: '第一志愿上岸',
        2: '调剂上岸',
        3: '推免',
      }
      return recruitTypes[type] || ''
    },
    renderGender(type) {
      const genders = {
        1: '学长',
        2: '学姐',
      }
      return genders[type] || ''
    },
    directionChange(e) {
      this.senior.recruit_direction_name = this.directionList.find((item) => {
        return item.direction_code === e //筛选出匹配数据
      }).direction
    },
    // 录取院校选择后还要搜索相对应的院校名称
    collegeChange(e) {
      this.collegeCode = e
      this.senior.recruit_major_code = ''
      this.senior.recruit_major_name = ''
      this.senior.recruit_academy_code = ''
      this.senior.recruit_academy_name = ''
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_direction_code = ''
      this.senior.recruit_direction_name = ''
      this.senior.recruit_college_name = this.$store.state.collegeList.find(
        (item) => {
          return item.code === e //筛选出匹配数据
        }
      ).name
      this.getAcademy(this.collegeCode)
      this.getMajor(this.collegeCode)
      this.$nextTick(() => {
        this.getMajor(e)
      })
    },
    // 录取院校选择后还要搜索相对应的院校名称
    academyChange(e) {
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_academy_name = this.academyList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name
    },
    getAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyList = res.list || []
      })
    },
    getMajor(college_code) {
      collegeMajorList({
        college_code: college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list || []
      })
    },
    // 录取方向
    majorDirect(college_code, major_code) {
      majorinfo({
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }).then((res) => {
        if (res.academys && res.academys.length) {
          let list = res.academys.map((item) => item.directions).flat()
          let obj = {}
          for (let item of list) {
            if (!obj[item.direction_code]) {
              obj[item.direction_code] = item
            }
          }
          this.directionList = Object.values(obj)
        }
      })
    },
    // 录取专业选择后还要搜索相对应的专业名称
    majorChange(e) {
      this.majorCode = e
      this.senior.test_subject_codes = ''
      this.senior.test_subject_names = ''
      this.senior.recruit_academy_code = ''
      this.senior.recruit_academy_name = ''
      this.senior.recruit_major_name = this.majorList.find((item) => {
        return item.code === e //筛选出匹配数据
      }).name

      this.collegeCode &&
        this.majorCode &&
        this.majorDirect(this.collegeCode, this.majorCode)

      this.$nextTick(() => {
        this.getSubjectsByMajorCode(this.senior.recruit_college_code, e)
      })
      this.$nextTick(() => {
        this.getAcademy(this.senior.recruit_college_code, e)
      })
    },
    getSubjectsByMajorCode(college_code, major_code) {
      let query = {
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list || []
      })
    },
    formateSenior() {
      let arr = []
      this.senior.test_subject_codes.map((item) => {
        this.subjectsList.map((v) => {
          if (item == v.subject_code) {
            arr.push(v.subject_name)
          }
        })
      })
      this.senior.test_subject_codes = this.senior.test_subject_codes.join(',')
      this.senior.test_subject_names = arr.join(',')
    },

    handleSubmit() {
      this.formateSenior()
      let query = {
        ...this.senior,
      }
      let arr = this.fileList.map((v) => {
        return v.url
      })
      let honName = []
      this.honors.map((item) => {
        this.honorList.map((itemk) => {
          if (item == itemk.id) {
            honName.push(itemk.label)
          }
        })
      })

      query.recruit_certify_img = arr.join(',')
      query.honor_tags_apply = honName.join(',') + ',' + '#' + this.otherHonor

      //  处理辅导科目
      if (this.tutorCheckList.length > 0) {
        let submitType = []
        let submitCertifyText = []
        let submitCertifyImg = []
        let submitService = []
        this.tutorCheckList.map((item) => {
          submitType.push(item.extra_tutoring_types)
          //证明理由
          if (item.extra_tutoring_certify_text != '') {
            submitCertifyText.push(item.extra_tutoring_certify_text)
          }
          //服务形式
          if (item.extra_service_types.length >= 2) {
            submitService.push(item.extra_service_types.join('-'))
          } else {
            submitService.push(item.extra_service_types[0])
          }

          //证明图片
          item.certifyImg = []

          item.tutoring_certify_img.map((v) => {
            item.certifyImg.push(v.url)
          })

          if (item.certifyImg.length >= 2) {
            submitCertifyImg.push(item.certifyImg.join('-'))
          } else {
            submitCertifyImg.push(item.certifyImg[0])
          }
        })
        query.extra_tutoring_types =
          submitType.length > 0 ? submitType.join(',') : ''
        query.extra_service_types =
          submitService.length > 0 ? submitService.join(',') : ''
        query.extra_tutoring_certify_text =
          submitCertifyText.length > 0 ? submitCertifyText.join(',') : ''
        query.extra_tutoring_certify_imgs =
          submitCertifyImg.length > 0 ? submitCertifyImg.join(',') : ''
      }

      editSeniorApply(query)
        .then((res) => {
          this.fetchSeniorInfo()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    handleApprove() {
      seniorApplyApprove({ senior_apply_id: this.senior.id }).then((res) => {
        this.$message.success('申请已通过')
        this.$emit('close')
        this.fetchSeniorInfo()
      })
      // 二次确认
      // this.$confirm('确定审核通过吗？', '提示', {
      //   type: 'warning',
      // })
      //   .then(() => {

      //   })
      //   .catch(() => {})
    },
    handleReject() {
      // 二次确认
      seniorApplyReject({ senior_apply_id: this.senior.id }).then((res) => {
        this.$message.success('申请已驳回')
        this.$emit('close')
        this.fetchSeniorInfo()
      })
      // this.$confirm('确定要驳回申请吗？', '提示', {
      //   type: 'warning',
      // })
      //   .then(() => {
      //     seniorApplyReject({ senior_apply_id: this.senior.id }).then((res) => {
      //       this.$message.success('申请已驳回')
      //       this.$emit('close')
      //       this.fetchSeniorInfo()
      //     })
      //   })
      //   .catch(() => {})
    },
    confirm() {
      this.handleSubmit()
      if (this.senior.status == 0) {
        if (this.userForm.status == 1) {
          this.handleApprove()
        } else if (this.userForm.status == 2) {
          this.handleReject()
        }
      }
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
/* 深度选择器：穿透 scoped 影响子组件样式 */
::v-deep .red-input .el-input__inner {
  border: 1px solid #ed7b2f;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
::v-deep .el-upload--picture-card {
  width: 80px;
  height: 80px;
}
/* 穿透 scoped 样式，修改输入框边框 */
::v-deep .inptScore .el-input__inner {
  border: none; /* 去掉默认边框 */
  box-shadow: none; /* 去掉聚焦时的阴影（可选，根据需求） */
}
::v-deep .el-form-item--small .el-form-item__label {
  font-size: 12px;
}

/* 去掉聚焦状态的边框（避免点击后出现边框） */
::v-deep .inptScore .el-input__inner:focus {
  border: none;
  box-shadow: none;
}
.dialog-wrap {
  ::v-deep .el-dialog__header {
    background: #ecf2fe;
  }
  .senioBox {
    padding-left: 16px;
    display: flex;
    .seniorItem {
      width: 400px;
      border-right: 1px solid #dcdfe6;
      .invite {
        margin-top: 12px;
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 14px;
        color: #303133;
        position: relative;

        .blue {
          margin-right: 6px;
          display: inline-block;
          width: 4px;
          height: 16px;
          background: #409eff;
          border-radius: 4px 4px 4px 4px;
        }
        .addSubject {
          position: absolute;
          right: 0px;
          font-weight: 400;
          font-size: 14px;
          color: #266fe8;
        }
      }
      .tutoringBox {
        margin-top: 16px;
        position: relative;
        .tutorName {
          font-weight: 700;
          font-size: 16px;
        }
        .tutoringDelete {
          position: absolute;
          top: 0px;
          right: 0px;
          color: red;
          font-size: 14px;
        }
      }
      .userForm {
        width: 350px;
        margin-top: 14px;
        .warning {
          line-height: 20px;
          padding: 0px !important;
          font-size: 12px;
          color: #ed7b2f;
        }
        .certify {
          margin-left: -150px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .score {
        min-width: 70px;
        border-radius: 3px 3px 3px 3px;
        border: 1px solid #dddddd;
        margin-top: 10px;
        display: flex;
        min-height: 35px;
        position: relative;
        .preScore {
          font-size: 12px;
          position: absolute;
          right: 5px;
        }

        .subjectName {
          min-width: 100px;
          min-height: 35px;
          padding-left: 6px;
          padding-right: 6px;
          line-height: 35px;
          font-size: 10px;
          display: inline-block;
          background: #eeeeee;
          border-radius: 1px 0px 0px 1px;
        }
      }
    }
  }
  .submit {
    cursor: pointer;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;

    font-size: 14px;
    .cancle {
      text-align: center;
      width: 56px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-right: 18px;
    }
    .confirm {
      width: 56px;
      height: 36px;
      color: #fff;
      text-align: center;
      line-height: 36px;
      background: #1f86fe;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
</style>
